import React, { Component } from "react";
import PropTypes from "prop-types";

import styles from "./RadioGroup.css";

export default class RadioGroup extends Component {
  constructor(props) {
    super(props);
    this.name = Math.random()
      .toString(36)
      .substring(2, 7);
    this.state = {
      selectedValue:
        this.props.selectedValue || this.props.children[0].props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedValue !== this.state.selectedValue) {
      this.setState({ selectedValue: nextProps.selectedValue });
    }
  }

  render() {
    const { selectedValue } = this.state;
    const { onChange } = this.props;
    const name = this.name;

    const childrenWithProps = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, { name, onChange, selectedValue });
    });

    return <div className={styles.root}>{childrenWithProps}</div>;
  }
}

RadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};
